import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import MonthGrid from "./MonthGrid";
import { addMonths } from "./dateRangeUtils";

const navBtnStyle = {
	background: "none", border: "none", cursor: "pointer",
	color: "var(--color-text-light)", padding: 4,
};

const DualMonthCalendar = ({ rangeStart, rangeEnd, onSelectDay }) => {
	const [leftMonth, setLeftMonth] = useState(() => addMonths(new Date(), -1));

	return (
		<div style={{ padding: 16 }}>
			<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
				<button onClick={() => setLeftMonth(m => addMonths(m, -1))} style={navBtnStyle}><FaChevronLeft size={11} /></button>
				<span style={{ fontSize: 11, color: "var(--color-text-light)" }}>Custom range</span>
				<button onClick={() => setLeftMonth(m => addMonths(m, 1))} style={navBtnStyle}><FaChevronRight size={11} /></button>
			</div>
			<div style={{ display: "flex", gap: 20 }}>
				<MonthGrid monthDate={leftMonth} rangeStart={rangeStart} rangeEnd={rangeEnd} onSelectDay={onSelectDay} />
				<MonthGrid monthDate={addMonths(leftMonth, 1)} rangeStart={rangeStart} rangeEnd={rangeEnd} onSelectDay={onSelectDay} />
			</div>
		</div>
	);
};

export default DualMonthCalendar;
